module.exports = __webpack_public_path__ + "static/assets/1a713b4445e4afb28cde39493301b4dd.svg";